export default __webpack_public_path__ + "static/media/image_arrow.6e8c0506.svg";